<script setup>

</script>

<template>
    <button type="button" class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#userProfileOffcanvas">
        <i class="me-2 bi bi-person"/>
        User profile
    </button>
</template>